import React from 'react';
import { Spin } from 'antd';
import { useTranslation } from 'react-i18next';

const LoadingState = () => {
  const { t } = useTranslation();

  return (
    <div className="flex justify-center items-center py-16">
      <div className="text-center">
        <Spin size="large" />
        <div className="mt-4 text-gray-600">
          {t('treatment|Loading treatments...')}
        </div>
      </div>
    </div>
  );
};

export default LoadingState;